// src/observer/ObserverVote.jsx
import React from "react";
import { DISC_RENK } from "../disc/discBrand";

// Paylaşım belgesinin paleti (src/disc/discBrand.js) — gözlemci ekranı da
// rapor ve admin ile aynı renkleri kullanır.
const COLORS = DISC_RENK;

export default function ObserverVote({ onVoteA, onVoteB }) {
  return (
    <div
      style={{
        height: "100vh",
        display: "grid",
        gridTemplateRows: "64px 1fr",
        gap: 8,
        padding: 8,
      }}
    >
      {/* Üst başlıklar */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          fontWeight: "bold",
          fontSize: 24,
          textAlign: "center",
        }}
      >
        <div>TEAM A</div>
        <div>TEAM B</div>
      </div>

      {/* Alt: iki kolon, her kolonda D I S C */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 8,
          alignItems: "stretch",
        }}
      >
        {/* Sol kolon: TEAM A */}
        <div style={{ display: "grid", gridTemplateRows: "repeat(4, 1fr)", gap: 8 }}>
          {["D", "I", "S", "C"].map((k) => (
            <button
              key={`A-${k}`}
              onClick={() => onVoteA(k)}
              style={{
                border: "none",
                borderRadius: 10,
                fontSize: "2rem",
                fontWeight: "bold",
                color: k === "I" ? "#000" : "#fff",
                background: COLORS[k],
              }}
            >
              {k}
            </button>
          ))}
        </div>

        {/* Sağ kolon: TEAM B */}
        <div style={{ display: "grid", gridTemplateRows: "repeat(4, 1fr)", gap: 8 }}>
          {["D", "I", "S", "C"].map((k) => (
            <button
              key={`B-${k}`}
              onClick={() => onVoteB(k)}
              style={{
                border: "none",
                borderRadius: 10,
                fontSize: "2rem",
                fontWeight: "bold",
                color: k === "I" ? "#000" : "#fff",
                background: COLORS[k],
              }}
            >
              {k}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
